var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{attrs:{"sm":"12"}},[_c('b-btn',{on:{"click":function($event){return _vm.loadPrev()}}},[_vm._v("Cargar datos de inspección previa")]),_vm._v("\n  "+_vm._s(_vm.msj)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }